/**
 * Utility functions for country flag URLs
 * Uses International Trade Centre (ITC) API for flag images
 * This is the official source used for political/trade reasons
 */

/**
 * Get the flag SVG URL for a given ISO numeric code
 * Uses ITC API: https://api.intracen.org/flags/{numericCode}.svg
 * @param codeISONumeric - ISO 3166-1 numeric code (e.g., '756' for Switzerland)
 * @returns The URL to the flag SVG from ITC API
 */
export function getCountryFlagUrlByNumeric(codeISONumeric: string): string | null {
  if (!codeISONumeric) {
    return null;
  }

  return `https://api.intracen.org/flags/${codeISONumeric}.svg`;
}

/**
 * Get the flag SVG URL for a given ISO alpha-2 country code
 * Note: Requires country lookup to get numeric code
 * For direct usage, prefer getCountryFlagUrlByNumeric with the numeric code
 * @param countryIso2 - ISO 3166-1 alpha-2 country code (e.g., 'CH')
 * @param numericCode - The ISO numeric code for the country
 * @returns The URL to the flag SVG, or null if code not provided
 * @deprecated Use getCountryFlagUrlByNumeric directly with numeric code from CountriesService
 */
export function getCountryFlagUrl(countryIso2: string, numericCode?: string): string | null {
  if (!numericCode) {
    return null;
  }

  return getCountryFlagUrlByNumeric(numericCode);
}
